// Mikro-onboarding — kurios užuominos jau parodytos (localStorage).
// Kiekviena rodoma tik vieną kartą; visą turą galima atstatyti (Pagalba).

const RAKTAS = 'onboarding_matyti'

export function matytiSarasas() {
  try {
    const r = localStorage.getItem(RAKTAS)
    return r ? JSON.parse(r) : []
  } catch {
    return []
  }
}

export function arMatyta(id) {
  return matytiSarasas().includes(id)
}

export function pazymetiMatyta(id) {
  try {
    const m = new Set(matytiSarasas())
    m.add(id)
    localStorage.setItem(RAKTAS, JSON.stringify([...m]))
  } catch {}
}

export function pazymetiMatytaKeli(ids) {
  try {
    const m = new Set(matytiSarasas())
    ids.forEach(id => m.add(id))
    localStorage.setItem(RAKTAS, JSON.stringify([...m]))
  } catch {}
}

// Atstatyti visą apžvalgą (peržiūrėti iš naujo per Pagalbą)
export function atstatytiOnboarding() {
  try { localStorage.removeItem(RAKTAS) } catch {}
}
